import {Doughnut} from 'vue-chartjs'
import renderChart from './renderChartMixin'

export default {
  name: "chart--pie",
  extends: Doughnut,
  mixins: [renderChart],
  props: {
    myDataset   : {type: Object , required : true},
    options     : {type: Object},
    showTooltip : {type: Boolean, default  : true},
    color       : {type: [Array, String] , default  :'#505050'}
  },
  data() {
    return {
      default: {
        tooltips:{
          enabled: this.showTooltip
        },
        legend: {
          display: false
        },
        cutoutPercentage: 82,
        responsive: false,
      }
    }
  },
  computed:{
    chartData(){
      var colors = [];

      if(this.color instanceof Array){
        colors = this.color;
      }
      else{
        for (var i = 0; i < this.myDataset.values.length; i++) {
          colors.push(i == 0 ? this.color : this.shadeColor(this.color, (i / this.myDataset.values.length)));
        }
      }

      return{
        datasets: [{
          data: this.myDataset.values,
          borderWidth: 0,
          backgroundColor: colors
        }],
        labels: this.myDataset.labels
      }
    }
  }
}